import axios from 'axios'
const http = axios.create({
  // baseURL: 'http://10.0.0.211:2121/reportapi',
  baseURL: 'http://drcresearch.drcnet.com.cn/reportapi',
  // baseURL: 'http://testresearch.drcnet.com.cn',
  // baseURL: 'http://testnewgysd.drcnet.com.cn/reportapi/',
  // 请求 30s 超时
  timeout: 300000
})

export default http
